module.exports = __webpack_public_path__ + "img/iphone_5.fed8c32d.png";